/**
 * 公共接口结果类
 */
export class TemplateResultClass {
    /**
     * 后台返回状态码
     */
    code: number;
    /**
     * 后台返回消息
     */
    msg: string;
}

/**
 * 公共分页类
 */
export class pagination {
    /**
     * 页码
     */
    pageIndex: number;
    /**
     * 分页大小
     */
    pageSize: number;
    /**
     * 总数量
     */
    totalCount: number;
}

/**
 * 当前文件请求接口头地址
 */
export const urlDesignFaceTeachQuestionnaire = '/api/XOrg/BookMaterial/';

import http from 'lib//http';


/**
 * 获取问卷调查列表url
 */
export const urlGetQuestionnaireList = urlDesignFaceTeachQuestionnaire + 'getFaceTeachQuestionnaireList';


/**
 * 获取问卷调查列表result
 */
export class QuestionnaireList {
    code : number;
    pagination:pagination;
    msg:string;
    list: {
        id:string,
        questionnaireName:string,
        dateCreated:string
    }[];
}

/**
 * 获取问卷调查列表function
 */
export function getQuestionnaireList(courseId: string, classId: string,faceId:string,classState:string, page?: number, questionnaireName?: string) {
    return http.post<TemplateResultClass>(urlGetQuestionnaireList, {
        courseId,
        classId,
        faceId,
        questionnaireName,
        classState,
        page
    });
}


/**
 * 获取问卷调查题目列表url
 */
export const urlGetQuestionnaireQuestionList = urlDesignFaceTeachQuestionnaire + 'getQuestionnaireStatistics';


/**
 * 获取问卷调查题目列表result
 */
export class QuestionnaireQueList {
    code : number;
    data: {
        questionId:string,
        title:string,
        dataJson:{
            Content:string,
            IsAnswer:string,
            OptionContent:string,
            OptionSelectContent:string,
            OptionAnswerContent:string,
            SortOrder:number
        }[],
        answer:string,
        questionType:string,
        sortOrder:number
    }[];
}

/**
 * 获取问卷调查题目列表function
 * @param courseId 
 * @param questionnaireId 
 */
export function getQuestionnaireQueList(courseId: string,questionnaireId:string) {
    return http.post<QuestionnaireQueList>(urlGetQuestionnaireQuestionList, {
        courseId,
        questionnaireId,
        type:1
    });
}


/**
 * 新建问卷调查url
 */
export const urlAddQuestionnaire = urlDesignFaceTeachQuestionnaire + 'addFaceTeachQuestionnaire';

/**
 * TemplateResultClass 公共返回值类型
 */

/**
 * 新建问卷调查function
 * @param courseId 
 * @param classId 
 * @param faceId 
 * @param questionnaireName 问卷调查的名称
 * @param classState 1课前/2课中/3课后
 */
export function addQuestionnaire(courseId: string,questionnaireName:string,classState:number) {
    return http.post<TemplateResultClass>(urlAddQuestionnaire, {
        courseId,
        questionnaireName,
        classState
    });
}

/**
 * 重命名问卷调查url
 */
export const urlRenameQuestionnaire = urlDesignFaceTeachQuestionnaire + 'updateQuestionnaireTitle';

/**
 * TemplateResultClass 公共返回值类型
 */

 /**
  * 重命名问卷调查function
  * @param questionnaireId 问卷id
  * @param questionnaireName 问卷名称
  */
export function renameQuestionnaire(questionnaireId: string,questionnaireName:string) {
    return http.post<TemplateResultClass>(urlRenameQuestionnaire, {
        questionnaireId,
        title:questionnaireName,
    });
}

/**
 * 开始问卷调查url
 */
export const urlStartQuestionnaire = urlDesignFaceTeachQuestionnaire + 'startQuestionnaire';

/**
 * TemplateResultClass 公共返回值类型
 */

 /**
  * 开始问卷调查function
  * @param questionnaireId 问卷id
  */
 export function startQuestionnaire(questionnaireId: string) {
    return http.post<TemplateResultClass>(urlStartQuestionnaire, {
        Id:questionnaireId
    });
}


/**
 * 结束问卷调查url
 */
export const urlEndQuestionnaire = urlDesignFaceTeachQuestionnaire + 'endQuestionnaire';

/**
 * TemplateResultClass 公共返回值类型
 */

 /**
  * 结束问卷调查function
  * @param questionnaireId 问卷id
  */
 export function endQuestionnaire(questionnaireId: string) {
    return http.post<TemplateResultClass>(urlEndQuestionnaire, {
        Id:questionnaireId
    });
}

/**
 * 删除问卷调查url
 */
export const urlDelQuestionnaire = urlDesignFaceTeachQuestionnaire + 'delQuestionnaire';

/**
 * TemplateResultClass 公共返回值类型
 */

 /**
  * 删除问卷调查function
  * @param questionnaireId 问卷id
  */
 export function delQuestionnaire(questionnaireId: string) {
    return http.post<TemplateResultClass>(urlDelQuestionnaire, {
        Id:questionnaireId
    });
}


/**
 * 新建或修改问卷调查题目url
 */
export const addQuestionnaireQuestionUrl = urlDesignFaceTeachQuestionnaire + 'addQuestionnaireDetail';

/**
 * TemplateResultClass 公共返回值类型
 */

  /**
  * 新建或修改问卷调查题目function
  */
 export function addQuestion(courseId:string,questionnaireId: string,questionId:string,title:string,dataJson:string,answer:string,questionType:number) {
    return http.post<TemplateResultClass>(addQuestionnaireQuestionUrl, {
        courseId,
        questionnaireId,
        questionId,
        title,
        dataJson,
        answer,
        questionType
    });
}

/**
 * 删除问卷调查题目url
 */
export const urlDeleteQuestionnaireQuestion = urlDesignFaceTeachQuestionnaire + 'delQuestion';

/**
 * TemplateResultClass 公共返回值类型
 */

 /**
  * 删除问卷调查题目function
  * 删除最后一题后需要传问卷id删删除问卷，反之传空字符串
  */
 export function deleteQuestionnaireQuestion(questionId:string,questionnaireId:string) {
    return http.post<TemplateResultClass>(urlDeleteQuestionnaireQuestion, {
        questionId:questionId,
        questionnaireId :questionnaireId
    });
}


/**
 * 统一保存问卷调查题目url
 */
export const urlUpdateQuestionnaireQuestion = '/api/XOrg/BookMaterial/updateQuestionnaireQuestions';

/**
 * TemplateResultClass 公共返回值类型
 */

 /**
  * 统一保存问卷调查题目function
  */
 export function updateQuestionnaireQuestion(courseId:string,questionnaireId:string,questionnaireName:string,questionJson:string) {
    return http.post<TemplateResultClass>(urlUpdateQuestionnaireQuestion, {
        courseId:courseId,
        questionnaireId:questionnaireId,
        questionnaireName:questionnaireName,
        questionJson:questionJson
    });
}


